/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_H1_Line2Inputs */

const es_ab_h1_line2 = /** @type {(inputs: Ab_H1_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comunidad náutica`)
};

const gl_ab_h1_line2 = /** @type {(inputs: Ab_H1_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comunidade náutica.`)
};

const en_ab_h1_line2 = /** @type {(inputs: Ab_H1_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`boating community.`)
};

/**
* | output |
* | --- |
* | "boating community." |
*
* @param {Ab_H1_Line2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_h1_line2 = /** @type {((inputs?: Ab_H1_Line2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_H1_Line2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_h1_line2(inputs)
	if (locale === "en") return en_ab_h1_line2(inputs)
	return es_ab_h1_line2(inputs)
});